<template>
  <section class="relative md:py-24 py-16">
    <div class="container">
      <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
        <div class="md:col-span-5">
          <div class="relative">
            <img src="../assets/images/business/about01.png" class="rounded-md" alt="">
<!-- 
            <div class="absolute bottom-24 right-0">
              <img src="../assets/images/logoBSD/logoBsd.svg" class="rounded-md shadow-md w-48 h-48" alt="">
              <div class="absolute bottom-2/4 translate-y-2/4 right-0 left-0 text-center">
                <a href="#!" data-type="youtube" data-id="yba7hPeTSjk"
                  class="lightbox h-14 w-14 rounded-full shadow-md dark:shadow-gyay-700 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-indigo-600">
                  <i class="mdi mdi-play inline-flex items-center justify-center text-xl"></i>
                </a>
              </div>
            </div> -->
          </div>
        </div><!--end col-->

        <div class="md:col-span-7">
          <div class="lg:ml-4">
            <h4 class="mb-6 md:text-3xl text-2xl lg:leading-normal leading-normal font-medium">Une solution polyvalente pour améliorer l'expérience client dans tous les secteurs
              </h4>
            <p class="text-slate-400 max-w-xl">Notre application de feedback est une solution polyvalente qui peut être utilisée dans tous les secteurs d'activité (vente au détail, hôtellerie,   restauration, services financiers, de technologie ou de santé,). Elle permet aux entreprises de recueillir des commentaires précieux de leurs clients, de résoudre rapidement leurs préoccupations et de suivre leur performance en temps réel.</p>
  
          </div>
        </div><!--end col-->
      </div><!--end grid-->
    </div><!--end container-->

   <!-- <div class="container md:mt-24 mt-16">
      <div class="grid grid-cols-1 pb-8 text-center">
        <h6 class="text-bsd-700 text-sm font-bold uppercase mb-2">Who We Are ?</h6>
        <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Business strategies and top
          <br> permormance ideas</h3>

        <p class="text-slate-400 max-w-xl mx-auto">Start working with Tailwind CSS that can provide everything you need to
          generate awareness, drive traffic, connect.</p>
      </div>

      <div class="grid md:grid-cols-3 grid-cols-1 mt-8 gap-[30px]">
        <div class="group text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-pie-chart h-10 w-10 stroke-1 group-hover:stroke-[1.5px] group-hover:text-indigo-600 transition-all duration-500 ease-in-out mx-auto">
            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
          </svg>

          <div class="mt-6">
            <a href=""
              class="text-xl font-semibold group-hover:text-indigo-600 transition-all duration-500 ease-in-out">Profitable
              Marketing</a>

            <p class="text-slate-400 mt-4">We develop digital strategies, products and services appreciated by clients.
            </p>

            <div class="mt-4">
              <a href="" class="btn btn-link hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">Read More
                <i class="uil uil-arrow-right align-middle"></i></a>
            </div>
          </div>
        </div>
       
        <div class="group text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-briefcase h-10 w-10 stroke-1 group-hover:stroke-[1.5px] group-hover:text-indigo-600 transition-all duration-500 ease-in-out mx-auto">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
          </svg>

          <div class="mt-6">
            <a href=""
              class="text-xl font-semibold group-hover:text-indigo-600 transition-all duration-500 ease-in-out">SEO
              Specialists</a>

            <p class="text-slate-400 mt-4">We develop digital strategies, products and services appreciated by clients.
            </p>

            <div class="mt-4">
              <a href="" class="btn btn-link hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">Read More
                <i class="uil uil-arrow-right align-middle"></i></a>
            </div>
          </div>
        </div>
      

        <div class="group text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-target h-10 w-10 stroke-1 group-hover:stroke-[1.5px] group-hover:text-indigo-600 transition-all duration-500 ease-in-out mx-auto">
          <circle cx="12" cy="12" r="10"></circle>
          <circle cx="12" cy="12" r="6"></circle>
          <circle cx="12" cy="12" r="2"></circle>
        </svg>

        <div class="mt-6">
          <a href=""
            class="text-xl font-semibold group-hover:text-indigo-600 transition-all duration-500 ease-in-out">Audience
            Analysis</a>

          <p class="text-slate-400 mt-4">We develop digital strategies, products and services appreciated by clients.
          </p>

          <div class="mt-4">
            <a href="" class="btn btn-link hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">Read More
              <i class="uil uil-arrow-right align-middle"></i></a>
          </div>
        </div>
      </div>
     
    </div>
  </div>end container-->
</section></template>

<script>
export default {

}
</script>

<style></style>